<template>
    <page>
        <module enable-flex>
            <view-list ref="view" :work-type="22">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="商户">
                            <c-select name="merchant_id" async @search="searchMerchant"></c-select>
                        </m-search-item>
                        <m-search-item label="商户名称">
                            <c-input name="merchant_name" placeholder="支持模糊查询"></c-input>
                        </m-search-item>
                        <m-search-item label="采购单号">
                            <c-input name="purchase_code"></c-input>
                        </m-search-item>
                        <m-search-item label="产品信息">
                            <c-input name="product_info" placeholder="品牌/型号/分类"></c-input>
                        </m-search-item>
                        <m-search-item label="采购员">
                            <c-input name="purchase_user_name" placeholder="请输入采购员"></c-input>
                        </m-search-item>
                        <m-search-item label="等级">
                            <c-select name="level_type" :options="LEVEL_TYPE"></c-select>
                        </m-search-item>
                        <m-search-item label="入库时间" colspan="2">
                            <c-datetime range start-name="stock_in_start_date" end-name="stock_in_end_date"></c-datetime>
                        </m-search-item>
                        <m-search-item label="操作部门">
                            <c-input name="operate_department"></c-input>
                        </m-search-item>
                        <m-search-item label="操作人">
                            <c-input name="operate_user_realname"></c-input>
                        </m-search-item>
                        <m-search-item label="供应部门">
                            <c-input name="purchase_department"></c-input>
                        </m-search-item>
                    </m-search>
                </template>

                <c-table-column type="button" label="操作" width="90" fixed="right">
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="$refs.remark.open(data)">查看备注</c-table-button>
                    </template>
                </c-table-column>

                <template #saas_info="{data}">
                    <div class="m-saas-info">
                        <p>{{data.saas_id || '-'}}</p>
                        <p class="m-saas-info-name">{{data.saas_name || '-'}}</p>
                    </div>
                </template>

                <template #product_info="{data}">
                    <m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>

                <template #purchase_code="{data}">
                    <div class="m-product-info">
                        <p class="m-product-info-name">采购单：{{data.purchase_code}}</p>
                        <p class="m-product-info-name">三方订单号：{{data.out_order_number}}</p>
                    </div>
                </template>

                <template #purchase_price="{data}">
                    <div class="m-product-info">
                        <p class="m-product-info-name">采购：￥{{data.purchase_price||0}}</p>
                        <p class="m-product-info-name">维修：￥{{data.repair_cost||0}}</p>
                    </div>
                </template>

                <template #is_dismantle="{data}">
                    <!--管理端仅展示拆机标记，不含悬停拆机订单查询-->
                    <span v-if="data.is_dismantle==1" class="m-dismantle-tag" title="已拆机">拆</span>
                    <span v-else>-</span>
                </template>

                <template #produce_unique_code="{data}">
                    {{data.produce_unique_code}} <c-link v-if="data.produce_unique_code" color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <template #produce_imei="{data}">
                    {{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <template #main_state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_MAIN_STATE" :value="data.main_state"></c-state>
                </template>

                <template #state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_STATE" :value="data.state"></c-state>
                </template>

                <template #cost_price="{data}">
                    {{formatPrice(data.cost_price)}}
                </template>

                <template #retail_price="{data}">
                    {{formatPrice(data.retail_price)}}
                </template>
            </view-list>
            <erp-code-remark ref="remark"></erp-code-remark>
        </module>
    </page>
</template>

<script>
import ErpCodeRemark from './components/code_remark.vue';
import {asyncMapState} from '@/store';

export default {
    name: 'erp_storage_balance',
    components: {ErpCodeRemark},
    computed: {
        ...asyncMapState(['LEVEL_TYPE'])
    },
    methods: {
        searchMerchant(keyword, resolve) {
            this.request({url: '/sys_saas/options', data: {keyword}, success: resolve});
        },
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        },
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        }
    }
};
</script>

<style scoped>
.m-product-info {line-height: 24px; font-size: 13px; color: #333;}
.m-product-info p {margin: 0;}
.m-product-info-name {display: flex; align-items: center; gap: 4px;}
.m-product-info-code {color: #999; font-size: 12px;}
.m-saas-info {line-height: 20px; font-size: 13px; color: #333;}
.m-saas-info p {margin: 0;}
.m-saas-info-name {color: #999; font-size: 12px;}
.m-dismantle-tag {display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; border: 1.5px solid #ed3f14; border-radius: 50%; color: #ed3f14; font-size: 13px; font-weight: bold;}
</style>
